module.exports = __webpack_public_path__ + "static/media/drakoskeep.a71482f2.jpg";